import React from 'react'
import './styles.css';

class WelcomeCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <div className="numberCard" >
                <div className="numberCardHead" style={this.props.style}>
                    {this.props.name}
                </div>
                <label> {this.props.text}</label>
            </div>
        )
    }
}

export default WelcomeCard;